import PlusIcon from '@/shared/assets/plus.svg?react';
import { Button } from '@/shared/components/ui/button';

export const AddButton = ({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) => {
  return (
    <Button variant={'greenGradient'} btnType="secondary" onClick={onClick}>
      <PlusIcon className="h-4 w-4" />
      <p className="hidden sm:block">{label}</p>
    </Button>
  );
};
